const { reject } = require("q");

var listPage = 1;
var sortValue = "";
var isShowTmsBlocksList = "";
var newVideo = null;
var activeVideo = null;
let activeKey = "";
let activeLiveId = undefined;
var playType = 1;
var playColumnid = 1;

window.slideTimer = function () {
    $(".nav-arrow-next").click();
};

$(function () {
    isShowTmsBlocksList = $(".middle").data("isshow");
    getSlides();
    getNews();
    // getColumns();
    // getSzList();
    // getList();
    listAnimation();
    specialSwiperPlay();
    activetySwiperPlay();
    getNewsRight();
    getArea();
    channelPlay(13560916, "live-item1", true, true);
    activityLive("live-item2");
    setInterval(() => {
        activityLive("live-item2");
    }, 2000);
    // getRecommends();
    // getYgwllist();
    $(".live-nav-item").on("click", function () {
        $(".live-nav-item").removeClass("live-nav-active");
        $(this).addClass("live-nav-active");
        channelPlay($(this).attr("data-liveId"), "live-item1", true, true);
        if (activeVideo) {
            activeVideo.pause();
        }
        // console.log();
    });
    var adsList = $("#ads").attr("data-ad");
    adsList = JSON.parse(adsList);
    if (adsList) {
        for (var key in adsList) {
            new Swiper("#" + key + "-sliders", {
                autoplay: 6000,
                loop: true,
                // speed: 1,
                mode: "vertical",
                pagination: "#" + key + "-sliders-dots",
                paginationClickable: true,
                autoplayDisableOnInteraction: false,
            });
        }
    }
    new Swiper("#newpaper-sliders", {
        autoplay: 6000,
        loop: true,
        // speed: 1,
        // mode: 'vertical',
        pagination: "#newpaper-sliders-dots",
        paginationClickable: true,
        autoplayDisableOnInteraction: false,
    });

    var ads = getPositionAds("ALLBG");
    if (ads["ALLBG"]) {
        var result = ads["ALLBG"];

        $("body").css({
            background: "url(" + result.ads[0].picture_url + ")",
            backgroundRepeat: "no-repeat",
            // backgroundAttachment: 'fixed',
            backgroundPosition: "center -130px",
        });

        $(".content").css({
            background: "#fff",
            boxSizing: "content-box",
            padding: "30px 25px 0 25px",
            marginTop: "400px",
        });
    }

    var int = setInterval("slideTimer()", 6000); // 1000为1秒钟

    $(".slide-list").on("mouseover", function () {
        window.clearInterval(int);
    });

    $(".slide-list").on("mouseout", function () {
        int = setInterval("slideTimer()", 6000); // 1000为1秒钟
    });

    $(".home-list .more").on("click", function () {
        getList();
    });

    $(".home-recommends .more").on("click", function () {
        location.href = ROOT + "/recommends";
    });

    $(".home-ygwl").on("click", function () {
        location.href = ROOT + "/ygwl";
    });
    getIframeHeight();
});
function getIframeHeight() {
    window.onload = function () {
        // console.log($('#newssc_iframe').contents().find('body'))
        // console.log($('#newssc_iframe').contents().find('.NPC').height());
        // console.log($('#newssc_iframe').contents().find('.NPC').offset());
        // console.log($('#newssc_iframe').contents().find('.NPC').offset().top);
        $(".iframe-box").height(
            $("#newssc_iframe").contents().find(".NPC").height()
        );
        $(".iframe-item").css(
            "margin-top",
            -$("#newssc_iframe").contents().find(".NPC").offset().top
        );
        $("#newssc_iframe").height(
            $("#newssc_iframe").contents().find(".NPC").height() +
                $("#newssc_iframe").contents().find(".NPC").offset().top
        );
    };
}
function channelPlay(id, liveClass, auto, muted) {
    if (!id) return;
    playColumnid = id;
    // $(".live-player img").remove();
    $.ajax({
        type: "get",
        async: false,
        url: ROOT + "/home/content?id=" + id,
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data == "") return;
            if (data.message !== undefined) {
                alert("获取频道信息错误:" + data.message);
                return;
            }
            if (
                !data ||
                !data.exdata ||
                !data.exdata.lives ||
                data.exdata.lives.length == 0
            ) {
                alert("获取直播扩展信息失败");
                console.log(data);
                return;
            }
            var obj = data.exdata.lives[0];
            var urls = [];
            // try {
            $("#content").removeClass("no-live");
            var playerId = "player_" + id;
            if (newVideo) {
                newVideo.dispose();
            }

            if (obj.flv_url) {
                urls.push(obj.flv_url);
            }
            if (obj.m3u8_url) {
                urls.push(obj.m3u8_url);
            }
            if (obj.rtmp_url) {
                urls.push(obj.rtmp_url);
            }
            if (urls.length > 0) {
                playType = obj.type;
                if (newVideo) {
                    // newVideo.pause()
                    newVideo.dispose();
                }
                if (obj.type == 1) {
                    $("." + liveClass).html(
                        '<video id="' +
                            playerId +
                            '" style="min-width: 588px; min-height: 330px;"  class="video-js vjs-big-play-centered"></video>'
                    );

                    // obj.m3u8_url = 'https://m3u8.channel.dzsm.com/nmip-media/channellive/channel100999/playlist.m3u8'
                    newVideo = startPlay([obj.m3u8_url], playerId, auto, muted);
                    // newVideo.on("play", function () {
                    //     if (activeVideo) {
                    //         activeVideo.pause()
                    //     }
                    // });
                }
                // else if (obj.type == 2) {
                //     $("." + liveClass).html(
                //         '<audio id="' +
                //         playerId +
                //         '" style="min-width: 588px; min-height: 330px;"  class="video-js vjs-big-play-centered"></audio>'
                //     );

                //     // 达州电视台广播相当于 带封面的视频播放器，
                //     var cover =
                //         data.pc_poster_url
                //             ? data.pc_poster_url
                //             : "";
                //     thumbnailPoster = cover;
                //     newVideo = startPlay(obj.m3u8_url, playerId, true, true, cover);

                // }
            } else {
                $("#content").addClass("no-live");
            }

            // $(".link-column-list").html("");
            // if (data.fields.link_column) {
            //     getLinkColumn(data.fields.link_column);
            // }
            // } catch (e) {
            //     console.log(e);
            //     alert("获取直播详细信息失败");
            //     return;
            // }
        },
        error: function (data) {
            console.log(data);
        },
    });
}
function activityLive(liveClass) {
    // $(".live-player img").remove();
    $.ajax({
        type: "get",
        async: false,
        url: ROOT + "/home/liveList?page=1&size=10&type=" + 2,
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            data = data.data;
            if (data == "") return;
            if (!Array.isArray(data)) {
                alert("直播信息获取错误");
                return;
            }
            // 筛选正在播放的活动直播
            data = data.filter((item) => item.type == 2 && item.state == 2);
            if (data && data.length == 0) {
                // alert('找不到直播信息')
                console.log("找不到直播信息");
                return;
            }
            // data.sort((a, b) => {
            //     return b.start_time - a.start_time
            // })
            // console.log(data);
            if (activeLiveId == data[0].id) {
                return;
            } else {
                activeLiveId = data[0].id;
                var playerId = "player_" + activeLiveId;
                if (activeVideo) {
                    activeVideo.pause();
                    activeVideo.dispose();
                }
                $.ajax({
                    type: "get",
                    async: false,
                    url: ROOT + "/home/liveInfo",
                    data: { id: activeLiveId },
                    contentType: "application/json",
                    dataType: "json",
                    success: function (data) {
                        if (
                            !data ||
                            !data.view_streams ||
                            data.view_streams.length == 0
                        ) {
                            // alert('找不到直播流')
                            console.log("找不到直播流");

                            return;
                        }
                        var url = data.view_streams[0].play_address;
                        $("." + liveClass).html(
                            '<video id="' +
                                playerId +
                                '" style="min-width: 588px; min-height: 330px;"  class="video-js vjs-big-play-centered"  ></video>'
                        );
                        // url = 'https://m3u8.channel.dzsm.com/nmip-media/channellive/channel100999/playlist.m3u8'
                        // url =
                        //     "https://director-view.dazhourm.cn:7070/director/102605.flv";
                        // console.log("urlurlurlurl", url);

                        activeVideo = startPlay(
                            [url],
                            playerId,
                            true,
                            true,
                            true
                        );
                        // activeVideo.play()
                        // activeVideo.on("pause", function () {
                        // });
                        // activeVideo.on("play", function () {
                        //     if (newVideo) {
                        //         newVideo.pause()
                        //     }
                        // });
                        // $('.live-item2 .vjs-big-play-button').click()
                        // console.log($('.live-item2 .vjs-big-play-button'));
                        // console.log(data);
                    },
                    error: function (data) {
                        console.log(data);
                    },
                });
            }
        },
        error: function (data) {
            console.log(data);
        },
    });
}
function specialSwiperPlay() {
    var specialSwiper = new Swiper("#special-sliders", {
        autoplay: 6000,
        loop: true,
        slidesPerView: 3,
        autoplayDisableOnInteraction: false,
    });
    $(".special-swiper-pre").click(function () {
        specialSwiper.swipePrev();
    });
    $(".special-swiper-next").click(function () {
        specialSwiper.swipeNext();
    });
}
function activetySwiperPlay() {
    var activitySwiper = new Swiper("#activity-sliders", {
        autoplay: 6000,
        loop: true,
        slidesPerView: 3,
        autoplayDisableOnInteraction: false,
    });
    $(".activity-swiper-pre").click(function () {
        activitySwiper.swipePrev();
    });
    $(".activity-swiper-next").click(function () {
        activitySwiper.swipeNext();
    });
}

$(window).scroll(function () {
    // 下面这句主要是获取网页的总高度，主要是考虑兼容性所以把Ie支持的documentElement也写了，这个方法至少支持IE8
    var htmlHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
    // clientHeight是网页在浏览器中的可视高度，
    var clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
    // scrollTop是浏览器滚动条的top位置，
    var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
    // 通过判断滚动条的top位置与可视网页之和与整个网页的高度是否相等来决定是否加载内容；
    // if (scrollTop + clientHeight >= htmlHeight) {
    //     if (listPage <= 2) getList();
    // }
});
function listAnimation() {
    var dom = document.querySelector(".szyw-right");
    var moveINterval = undefined;
    moveINterval = setInterval(function () {
        leftMove(dom);
    }, 30);
    $(".szyw-right").on("mousemove", function () {
        if (moveINterval) {
            clearInterval(moveINterval);
            moveINterval = undefined;
        } else {
        }
    });
    $(".szyw-right").on("mouseleave", function () {
        if (moveINterval) {
        } else {
            moveINterval = setInterval(function () {
                leftMove(dom);
            }, 30);
        }
    });
}
function leftMove(dom) {
    if (dom) {
        if (dom.scrollLeft != dom.scrollWidth - dom.clientWidth) {
            dom.scrollLeft += 1;
        } else {
            // dom.scrollLeft = dom.getElementsByTagName('li')[0].clientWidth
            dom.scrollLeft = 0;
        }
    }
}
function getSlides() {
    $.ajax({
        type: "get",
        async: false,
        url: "/home/slides",
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data == "") return;
            if (data.message !== undefined) {
                alert("操作失败:" + data.message);
                return;
            }
            if (data.data === undefined && data.data.length == 0) {
                alert("操作失败");
                return;
            }
            var newlist = "";
            var dotsHtml = "";
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];
                if (i == 0)
                    newlist +=
                        '<div class="slide-item current" data-index="' +
                        i +
                        '">';
                else
                    newlist +=
                        '<div class="slide-item" data-index="' + i + '">';
                newlist += '<a href="' + info.url + '" target="_blank">';
                if (info.pc_poster_url != "")
                    newlist +=
                        '<img src="' +
                        info.pc_poster_url +
                        '?w=610&h=343&s=3" />';
                else if (info.thumbnail_urls.length > 0)
                    newlist +=
                        '<img src="' +
                        info.thumbnail_urls[0] +
                        '?w=610&h=343&s=3" />';
                else newlist += '<img src="" />';
                newlist += "<p>" + info.title + "</p>";
                newlist += "</a>";
                newlist += "</div>";

                dotsHtml +=
                    '<span class="' +
                    (i === 0 ? "nav-dot-current" : "") +
                    '" data-index="' +
                    i +
                    '"></span>';
            }

            $("#nav-dots").html(dotsHtml);
            $(".slide-list .slide-items").append(newlist);
            var width = 100 / parseInt(data.data.length);
            // $('#nav-dots span').css('width', width + '%');
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert("获取列表失败:" + data.message);
            else alert("获取列表失败");
        },
    });
}

function getNews() {
    $.ajax({
        type: "get",
        async: false,
        url: "/home/news",
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data == "") return;
            if (data.message !== undefined) {
                alert("操作失败:" + data.message);
                return;
            }
            if (data.data === undefined) {
                alert("操作失败");
                return;
            }
            if (data.data.length < 2) return;
            var newlist = "";
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];
                newlist +=
                    '<div class="home-news-item">\
                        <a href="' +
                    info.url +
                    '"><img src="' +
                    info.thumbnail_urls[0] +
                    '?w=370&h=156&s=3" /></a>\
                    </div>';
            }

            $(".home-news").html(newlist);
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert("获取列表失败:" + data.message);
            else alert("获取列表失败");
        },
    });
}

function getNewsRight() {
    var key = $(".news-right").attr("data-columnKey");
    if (key) {
        getChildrenColumns(key)
            .then((childrenColumn) => {
                if (childrenColumn.length > 0) {
                    var columns = childrenColumn.slice(0, 11).map((item) => {
                        item.url = "/cms/column/" + item.key;
                        return item;
                    });
                    let html = "";
                    columns.forEach((item, index) => {
                        html += `<a href="${item.url}" target="_blank" rel="noopener noreferrer">`;
                        html +=
                            index == 7
                                ? ` <div class="news-right-item big-news-right-item">`
                                : ` <div class="news-right-item">`;
                        html += `${item.name}</div></a>`;
                    });
                    $(".news-right").html(html);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
}
function getArea() {
    let key = $(".area-menu").attr("data-area");
    if (key) {
        getChildrenColumns(key)
            .then((childrenColumn) => {
                let html = '<span class="block-label"></span>';
                childrenColumn.forEach((item, index) => {
                    html += `<span class="area-menu-item ${
                        index == 0 ? "area-menu-active" : ""
                    }" id="${item.key}" data-key="${item.key}">${
                        item.name
                    }</span>`;
                });
                $(".area-menu").html(html);
                clickMenuItem();
                $(".area-menu-item")[0].click();
                let itemWidth = 0;
                $(".area-menu")
                    .children()
                    .each(function () {
                        itemWidth += $(this).outerWidth();
                    });
                // 动态设置区域导航滚动条
                if (itemWidth >= 1346) {
                    $(".area-menu").css("overflow-x", "scroll");
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
}
function clickMenuItem() {
    $(".area-menu-item").on("click", function () {
        let key = $(this).attr("data-key");
        $(".area-menu-item").removeClass("area-menu-active");
        $(this).addClass("area-menu-active");
        getColumnInfo(key)
            .then((contents) => {
                let html = "";
                contents.slice(0, 2).forEach((item, index) => {
                    if (index == 0) {
                        html += `<a href="${
                            item.url
                        }" target="_blank" rel="noopener noreferrer">
                <img src="${
                    item.thumbnail_urls[0]
                        ? item.thumbnail_urls[0] + "?w=333&h=188&s=3"
                        : "/static/images/default.png"
                }" alt="" width="333" height="188" />
                </a>`;
                    } else {
                        html += `<li class="ellipse strong-li" style="margin-top:12px">
                    <a href="${item.url}" target="_blank" rel="noopener noreferrer">${item.title}</a>
                </li>`;
                    }
                });
                $(".area-content-left").html(html);
                html = "";
                contents.slice(2, 8).forEach((item, index) => {
                    html +=
                        `<li class="ellipse ` +
                        `${index == 0 ? "strong-li" : ""} ">
                    <a href="${
                        item.url
                    }" target="_blank" rel="noopener noreferrer">${
                            item.title
                        }</a>
                </li>`;
                });
                $(".area-content-center").html(html);
                html = "";
                contents.slice(8, 14).forEach((item, index) => {
                    html +=
                        `<li class="ellipse ` +
                        `${index == 0 ? "strong-li" : ""} ">
                    <a href="${
                        item.url
                    }" target="_blank" rel="noopener noreferrer">${
                            item.title
                        }</a>
                </li>`;
                });
                $(".area-content-right").html(html);
            })
            .catch((err) => {
                console.log(err);
            });
    });
}
function getColumnInfo(params) {
    return new Promise((reslove, reject) => {
        $.ajax({
            type: "get",
            async: false,
            url: "/home/columnInfo",
            data: { key: params, page: 1, size: 14 },
            contentType: "application/json",
            dataType: "json",
            success: function (data) {
                if (data == "") return;
                if (data.message !== undefined) {
                    alert("操作失败:" + data.message);
                    return;
                }
                reslove(data.data);
            },
            error: function (data) {
                reject(data);
            },
        });
    });
}
function getChildrenColumns(parent) {
    return new Promise((reslove, reject) => {
        $.ajax({
            type: "get",
            async: false,
            url: "/home/columns",
            data: null,
            contentType: "application/json",
            dataType: "json",
            success: function (data) {
                if (data == "") return;
                if (data.message !== undefined) {
                    alert("操作失败:" + data.message);
                    return;
                }
                let parentColumn = data.filter((item) => {
                    return item.key == parent;
                });
                if (parentColumn.length > 0) {
                    var parentId = parentColumn[0].id;
                    var childrenColumn = data.filter((item) => {
                        return item.parent_id == parentId;
                    });
                }

                if (childrenColumn) {
                    reslove(childrenColumn);
                } else {
                    reject("未找到栏目");
                }
            },
            error: function (data) {
                reject(data);
            },
        });
    });
}

function getSzList() {
    $.ajax({
        type: "get",
        async: false,
        url: "/home/list?page=1&sortValue=" + sortValue,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data == "") return;
            if (data.message !== undefined) {
                alert("操作失败:" + data.message);
                return;
            }
            if (isShowTmsBlocksList && data.length > 0) {
                sortValue = data[data.length - 1].sort_value;
                data.data = data;
            } else {
                if (data.data === undefined) {
                    alert("操作失败");
                    return;
                }
            }
            var newlist = "";

            if (data.data.length > 0) {
                for (var i = 0; i < data.data.length; i++) {
                    var sz = data.data[i];
                    if (i == 0) {
                        newlist += "";
                    }
                }
            }
            console.log(data);
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert("获取列表失败:" + data.message);
            else alert("获取列表失败");
        },
    });
}
function getList() {
    $.ajax({
        type: "get",
        async: false,
        url: "/home/list?page=" + listPage + "&sortValue=" + sortValue,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data == "") return;
            if (data.message !== undefined) {
                alert("操作失败:" + data.message);
                return;
            }
            if (isShowTmsBlocksList && data.length > 0) {
                sortValue = data[data.length - 1].sort_value;
                data.data = data;
            } else {
                if (data.data === undefined) {
                    alert("操作失败");
                    return;
                }
            }

            var id = getColumnID("list");
            var ad = {};
            if (id != null && id != 0) {
                ad = getListAds(id, 10 * listPage - 9, 10 * listPage);
            }
            var newlist = toListHtml(data, ad, listPage * 10 - 9);

            $(".home-list-items").append(newlist);

            listPage++;
            if (data.data.length < 10)
                $(".home-list .more").addClass("no-more");
            else $(".home-list .more").css("display", "block");
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert("获取列表失败:" + data.message);
            else alert("获取列表失败");
        },
    });
}

function getRecommends() {
    $.ajax({
        type: "get",
        async: false,
        url: "/home/recommends",
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data == "") return;
            if (data.message !== undefined) {
                return;
            }
            if (data.data === undefined) {
                return;
            }
            var newlist = "";
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];
                newlist += '<div class="recommends-item">';
                newlist +=
                    '<div class="recommends-item-title"><a href="' +
                    info.url +
                    '" target="_blank">' +
                    info.title +
                    "</a></div>";
                newlist +=
                    '<div class="recommends-item-time">' +
                    info.publish_time +
                    "</div>";
                newlist += "</div>";
            }

            $(".home-recommends .recommends-items").html(newlist);
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert("获取列表失败:" + data.message);
            else alert("获取列表失败");
        },
    });
}

function getYgwllist() {
    $.ajax({
        type: "get",
        async: false,
        url: "/home/ygwl",
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data == "") return;
            if (data.message !== undefined) {
                return;
            }
            if (data.data === undefined) {
                return;
            }
            var newlist = "";
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];
                newlist += '<div class="ygwl-item">';
                newlist +=
                    '<div class="ygwl-item-title"><a href="' +
                    info.url +
                    '" target="_blank">' +
                    info.title +
                    "</a></div>";
                newlist += "</div>";
            }

            $(".ygwl-list").html(newlist);
        },
        error: function (data) {
            console.log(data);
        },
    });
}

function toListHtml(data, advertisement, index) {
    var newlist = "";
    for (var i = 0; i < data.data.length; i++) {
        // 列表广告
        if (advertisement && advertisement[index + i]) {
            var ad = advertisement[index + i];
            var url =
                "/ads-click?id=" +
                ad.id +
                "&ad_id=" +
                ad.ad.id +
                "&ad_type=4" +
                "&url=" +
                encodeURIComponent(ad.ad.link_url);
            if (ad.list_mode == 0) {
                // 单图
                newlist += '<div class="newsItem">';
                if (ad.show_pictures.length > 0) {
                    newlist += '<div class="ads-picture">';
                    newlist +=
                        '<a href="' +
                        url +
                        '" target="_blank"><img src="' +
                        ad.show_pictures[0] +
                        "?w=170&h=114&s=3" +
                        '"/></a>';
                    newlist += "</div>";
                }
                newlist +=
                    '<a class="ads-title" href="' +
                    url +
                    '" target="_blank">' +
                    ad.name +
                    "</a>";
                newlist += '<div class="ad-tag">广告</div>';
                newlist += "</div>";
                newlist += '<div class="dividing-line"></div>';
            } else if (ad.list_mode == 1) {
                // 三图
                newlist += '<div class="newsItem">';
                newlist += '<div class="news_body">';
                newlist +=
                    '<a class="news_title" href="' +
                    url +
                    '" target="_blank">' +
                    ad.name +
                    "</a>";
                newlist += '<div class="adPicture">';
                for (var j = 0; j < ad.show_pictures.length; j++) {
                    if (j == 3) break;
                    newlist +=
                        '<a href="' +
                        url +
                        '" target="_blank"><img src="' +
                        ad.show_pictures[j] +
                        "?w=224&h=140&s=3" +
                        '"/></a>';
                }
                newlist += "</div>";
                newlist += "</div>";
                newlist += '<div class="ad-tag">广告</div>';
                newlist += "</div>";
                newlist += '<div class="dividing-line"></div>';
            } else if (ad.list_mode == 2) {
                // 大图
                newlist += '<div class="newsItem">';
                if (ad.show_pictures.length > 0) {
                    newlist += '<div class="ads-picture big">';
                    newlist +=
                        '<a href="' +
                        url +
                        '" target="_blank"><img src="' +
                        ad.show_pictures[0] +
                        "?w=320&h=200&s=3" +
                        '"/></a>';
                    newlist += "</div>";
                }
                newlist +=
                    '<a class="ads-title" href="' +
                    url +
                    '" target="_blank">' +
                    ad.name +
                    "</a>";
                newlist += '<div class="ad-tag">广告</div>';
                newlist += "</div>";
                newlist += '<div class="dividing-line"></div>';
            } else if (ad.list_mode == 4) {
                // 横幅
                newlist += '<div class="newsItem">';
                newlist +=
                    '<a href="' +
                    url +
                    '" target="_blank"><img src="' +
                    ad.show_pictures[0] +
                    "?w=746&h=114&s=3" +
                    '"/></a>';
                // newlist += '<div class="ad-tag">广告</div>';
                newlist += "</div>";
                newlist += '<div class="dividing-line"></div>';
            }
        }
        var info = data.data[i];

        if (isShowTmsBlocksList) {
            info.thumbnail_urls = info.thumbnails;
        }
        if (
            info.thumbnail_urls === undefined ||
            info.thumbnail_urls == null ||
            info.thumbnail_urls == ""
        ) {
            info.thumbnail_urls = [];
        }

        if (info.type === "banner") {
            newlist += '<div class="newsItem bannerItem">';
            newlist +=
                '<a href="' +
                info.url +
                '" target="_blank" rel="noopener noreferrer">';

            if (info.thumbnail_urls && info.thumbnail_urls[0].url) {
                newlist +=
                    '<img src="' + info.thumbnail_urls[0].url + '" alt=""/>';
            } else {
                newlist += '<img src="' + info.thumbnail_urls[0] + '" alt=""/>';
            }
            newlist += "</a>";
            newlist += "</div>";
            newlist += '<div class="dividing-line"></div>';
            continue;
        }

        var bottominfo = "";
        bottominfo += '<div class="news_info">';
        if (info.publisher && info.publisher.nickname) {
            bottominfo +=
                '<div class="user">' + info.publisher.nickname + "</div>";
        } else {
            if (info.author_nickname)
                bottominfo +=
                    '<div class="user">' + info.author_nickname + "</div>";
        }
        bottominfo += '<div class="time">' + info.publish_time + "</div>";
        bottominfo += '<div class="reply">';
        if (info.comment_count > 0)
            bottominfo +=
                '<div class="reply_count">' + info.comment_count + "评论</div>";
        if (info.view_count > 0)
            bottominfo +=
                '<div class="reply_count">' + info.view_count + "浏览</div>";
        bottominfo += "</div>";

        if (info.source && !isShowTmsBlocksList)
            bottominfo += '<div class="source">来源: ' + info.source + "</div>";
        bottominfo += "</div>";

        newlist += '<div class="newsItem">';
        // 只显示有图和无图两种情况
        if (
            info.list_item_mode == 0 ||
            info.thumbnail_urls.length == 0 ||
            !info.thumbnail_urls[0]
        ) {
            // 无图
            newlist += '<div class="newsInfo">';
            newlist += '<div class="news_body">';
            newlist +=
                '<a class="news_title" href="' +
                info.url +
                '" target="_blank">' +
                info.title +
                "</a>";
            newlist += '<div class="news_content">';
            if (info.summary) newlist += info.summary;
            newlist += "</div>";
            newlist += "</div>";
            newlist += bottominfo;
            newlist += "</div>";
            console.log("无图");
        } else {
            newlist += '<div class="newsPicture">';
            newlist += '<a href="' + info.url + '" target="_blank">';
            if (info.thumbnail_urls && info.thumbnail_urls[0].url) {
                newlist +=
                    '<img src="' +
                    info.thumbnail_urls[0].url +
                    "?w=200&h=150&s=3" +
                    '"/>';
            } else {
                newlist +=
                    '<img src="' +
                    info.thumbnail_urls[0] +
                    "?w=200&h=150&s=3" +
                    '"/>';
            }

            newlist += "</a>";
            newlist += "</div>";
            newlist += '<div class="newsInfo">';

            newlist += '<div class="news_body">';
            newlist +=
                '<a class="news_title" href="' +
                info.url +
                '" target="_blank">' +
                info.title +
                "</a>";
            newlist += '<div class="news_content">';
            if (info.summary) newlist += info.summary;
            newlist += "</div>";
            newlist += "</div>";
            newlist += bottominfo;
            newlist += "</div>";
        }
        newlist += "</div>";
        newlist += '<div class="dividing-line"></div>';
    }
    return newlist;
}
